import { useRouteChangeStart } from '../useAppRouter';
import { closeAnyModal } from '../../features/modals/modals.slice';
import { useAppDispatch } from '../useReduxToolkit';

/**
 * The hook is responsible for ensuring that modals are
 * automatically dismissed when the user navigates to a different page.
 */
export const useCloseModalOnRouteChange = (): void => {
  const dispatch = useAppDispatch();

  const handleRouteChangeStart = (): void => {
    dispatch(closeAnyModal());
  };

  useRouteChangeStart(handleRouteChangeStart);
};
